'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./GalleryPopup.less');
require('slick-carousel');

module.exports = Backbone.View.extend({

    el: '.GalleryPopup',

    events: {
        'click .GalleryPopup-close': 'onCloseClick'
    },

    initialize: function (props) {
        _.bindAll(this, 'onResize', 'onKeydown');

        window.addEventListener('resize', this.onResize);
        window.addEventListener('keydown', this.onKeydown);

        this.$('.GalleryPopup-slides').slick({
            adaptiveHeight: false,
            prevArrow: this.$('.GalleryPopup-prevArrow'),
            nextArrow: this.$('.GalleryPopup-nextArrow'),
            draggable: true,
            initialSlide: props.currentSlide || 0
        });

        this.$('.GalleryPopup-nextArrow').focus();
        this.$('.GalleryPopup-slides').on('setPosition', this.onResize);

        this.onResize();
    },

    onKeydown: function (event) {
        if (event.code !== 'Escape') {
            return;
        }

        this.onCloseClick();
    },

    onResize: function () {
        const item = this.$('.GalleryPopup-slideAspect:visible')[0];
        const width = $(item).attr('data-width') - 0;
        const height = $(item).attr('data-height') - 0;
        const bb = $(item).parent()[0].getBoundingClientRect();

        const innerResize = () => {
            this.$('.GalleryPopup-slideAspect').each((index, item) => {
                const description = $(item).find('.GalleryPopup-description')[0];
                const bbWidth = bb.width;
                const bbHeight = bb.height - (description ? description.offsetHeight + 30 : 0);

                let w;
                let h;

                if (width / height > bbWidth / bbHeight) {
                    w = bbWidth;
                    h = height / width * w;
                } else {
                    h = bbHeight;
                    w = width / height * h;
                }

                item.style.width = w + 'px';
                item.style.height = h + 'px';
                item.style.top = (bbHeight - h) / 2 + 'px';
                item.style.left = (bbWidth - w) / 2 + 'px';
            });
        };

        innerResize();
        innerResize(); //recalc text size on new image size
    },


    onCloseClick: function () {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('keydown', this.onKeydown);
        window.document.documentElement.classList.remove('hasActiveModals');
        this.remove();
    }
});


